import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import iq_api_v2 from '../../services/iqApiV2';
import { useUser } from '../../context/UserContext';

export default function VerifyThirdPartyLogin() {
  const { user } = useUser();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const pageAfterLoginUrl = localStorage.getItem("pageAfterLoginUrl");
  const afterLoginPageParams = JSON.parse(localStorage.getItem("afterLoginPageParams"));

  useEffect(() => {
    const verifyLogin = async () => {
      if (user?.id && code) {
        try {
          // const queryString = { 'code': code }; // Assuming you want to send the code
          // const upload_response = await iq_api_v2.get("/outlook/callback?", queryString, {
          //   headers: {
          //     'Content-Type': 'application/x-www-form-urlencoded',
          //     'Accept': 'application/json',
          //   },
          // });

          //return false;

          // const response = await iq_api_v2.get("/outlook/callback?code="+code+"&user_id="+user.id, '', {
          //     headers: {
          //     'Content-Type': 'application/x-www-form-urlencoded',
          //     'Accept': 'application/json',
          //   },
          // });

          const data = {
            code: code,
            user_id: user.id,
            email: user?.email || '',
            client_name : afterLoginPageParams?.clientName || '',
            account : afterLoginPageParams?.accountName || '',
          };

          //return false;
          
          const response = await iq_api_v2.get('/outlook/callback', {
            params: {...data},
            headers: {
              'Accept': 'application/json'
            }
          });

          const success =
          response?.status === 200 ||
          response?.status === 201
            ? true : false;

          if(success){
            const tokenData = response?.data?.token_data;
            // localStorage.setItem("tokenData", JSON.stringify(tokenData));
            console.log("Response:", tokenData);
          }else{
          //  localStorage.removeItem("tokenData");
          }
          window.opener.postMessage('refresh-parent', window.location.origin);
          window.close();

          // Optionally redirect after login
          // if (pageAfterLoginUrl) {
          //  window.location.href = pageAfterLoginUrl;
          // }
        } catch (error) {
          console.error("Login verification failed:", error);
        }
      }
    };

    verifyLogin();
  }, [user, code, pageAfterLoginUrl]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FFF',
        marginTop: '20%'
      }}
    >
      <div className='row'>
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-12'>
                <div className='center pt-3'>
                  Getting Verified..
                </div>
                <div className='center'>
                  <img src="/img/loader.gif" alt="Loading..." style={{ maxHeight: '100px', }} />
                </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
}